module.exports = __webpack_public_path__ + "media/images/favicons/apple-icon-180x180-52a33e06c2d2a344187102b12ef98206.png";